import { useTranslation } from 'react-i18next';
import { FILTER_ICONS } from '../../shared';

const FilterCheckbox = ({ attribute, value, updateValue }) => {
  const [t] = useTranslation();

  return (
    <div className="checkbox" key={attribute}>
      <label>
        <input
          type="checkbox"
          name={attribute}
          checked={value == 'yes'}
          onChange={() => updateValue(attribute, value == 'yes' ? 'no' : 'yes')}
        />
        <span className="filter-description">
          {t(`career_overview_page:filter_names.${attribute}`)}
          &nbsp;
          <i
            className={FILTER_ICONS[attribute]}
            title={I18n.t(`icons.${attribute}`)}
          ></i>
        </span>
      </label>
    </div>
  );
};

export default FilterCheckbox;
